<div class="">
  <div class="outer">
    <div class="inner justify-content-center d-flex align-items-center flex-wrap">
        <div class="d-flex">
            <div class="button" (click)="openChats()">
                <fa-icon [icon]="faIcons.faPersonFalling"></fa-icon>
                <span *ngIf="unreadMessageCount > 0" class="position-absolute top-0 translate-middle badge rounded-pill bg-danger">
                    {{unreadMessageCount}}
                  <span class="visually-hidden">unread messages</span>
                </span>
            </div>
            <div class="button" (click)="rewind()">
                <fa-icon [icon]="faIcons.faBackward"></fa-icon>
            </div>
            <div class="button" (click)="goHome()">
                <fa-icon [icon]="faIcons.faHouseChimney"></fa-icon>
            </div>
        </div>
        <div class="d-flex coordinate-holder align-items-center">
            <div class="button" (click)="zoomOut()">
                <fa-icon [icon]="faIcons.faPlaneDeparture"></fa-icon>
            </div>
          <div class="d-flex arrow-box align-items-center justify-content-center">
            <fa-icon [icon]="faIcons.faArrowsLeftRight"></fa-icon>
          </div>
          <div *ngFor="let s of coordXList" class="d-flex coordinate-box align-items-center justify-content-center">
            {{s}}
          </div>
          <div class="mx-1">:</div>
          <div *ngFor="let s of coordYList" class="d-flex coordinate-box align-items-center justify-content-center">
            {{s}}
          </div>
          <div class="d-flex arrow-box align-items-center justify-content-center">
            <fa-icon [icon]="faIcons.faArrowsUpDown"></fa-icon>
          </div>
        </div>
        <div class="d-flex">
            <div class="button">
                <fa-icon  data-toggle="tooltip" data-placement="top" title="Network connected"
                        *ngIf="networkConnected && !networkNotResponsive && !networkSlow" [icon]="faIcons.faHandshakeAngle"></fa-icon>
                <fa-icon data-toggle="tooltip" data-placement="top" title="Network latency is higher than normal"
                        *ngIf="networkConnected && !networkNotResponsive && networkSlow" [icon]="faIcons.faSpinner"></fa-icon>
                <fa-icon data-toggle="tooltip" data-placement="top" title="Unable to reach the network"
                        style="color: darkred" *ngIf="!networkConnected || networkNotResponsive" [icon]="faIcons.faSatelliteDish"></fa-icon>
            </div>
            <div class="button d-flex" (click)="changeZoom()">
              <fa-icon [icon]="faIcons.faMagnifyingGlassPlus"></fa-icon>
              <div class="ms-1">{{zoomDisplay}}</div>
            </div>
<!--            <div class="button" (click)="createNewPost()">-->
<!--              <fa-icon [icon]="faIcons.faPenToSquare"></fa-icon>-->
<!--            </div>-->
            <div class="button" (click)="createNewItem()">
                <fa-icon [icon]="faIcons.faPlus"></fa-icon>
            </div>
        </div>
    </div>
  </div>
</div>
